export default __webpack_public_path__ + "static/media/Path510.ce937f7f.png";